import React, { useEffect, useState } from 'react';
import styled from 'styled-components'
import hexToRgba from 'hex-to-rgba'

import Scroll from '../common/Scroll';
import { useStore } from 'react-redux';
import { language } from '../../utils/languageConsts'
import makkaraImage from '../../assets/img/makkara/makkara_2.jpg'
import headerMakkara from '../../assets/img/header_makkara.svg'
import MakkaraButton from '../common/MakkaraButton'

const IntroSection = styled.section`
	&:before {
		content: '';
		background-color: ${hexToRgba('#5e42a6', 0.6)};
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-size: cover;
	}
	background-image: url(${makkaraImage});
`

const MakkaraImage = styled.img`
  max-width: 50px;
`

const Introduction = () => {
  const store = useStore()
  const [currentLanguage, setCurrentLanguage] = useState(store.getState().language.language )
  useEffect(() => store.subscribe(() => {
		const lang = store.getState().language.language
		setCurrentLanguage(lang)
  }), [store])

  return (
    <IntroSection
      id="intro"
      className="wrapper style1 fullscreen fade-up"
    >
      <div className="inner">
        <h1>
          <MakkaraImage src={headerMakkara} />
          <span>
            {language[currentLanguage].TITLE}
          </span>
        </h1>
        <p>
        {language[currentLanguage].SUB_TITLE}
        </p>
        <ul className="actions">
          <li>
            <Scroll type="id" element="one">
              <MakkaraButton
                strokeColor="#312450"
                strokeWidth="3px"
                text="Learn more"
                fillOnHover="#312450"
                strokeOnHover="#ffffff"
                onClick={() => alert("hello")}
                rotate={0}
                top={13}
              />
            </Scroll>
          </li>
          <li>
            <Scroll type="id" element="one">
              <MakkaraButton
                strokeColor="#312450"
                strokeWidth="3px"
                text="Sign up"
                fillOnHover="#312450"
                strokeOnHover="#ffffff"
                onClick={() => alert("hello")}
                rotate={180}
                top={0}
              />
            </Scroll>
          </li>
        </ul>
      </div>
    </IntroSection>
  )
}


export default Introduction;
